<template>
  <v-container fluid>
    <PeriodCollege_govem_id :period_college_id="period_college_id"/>
    <Alert_salary_gov />
  </v-container>
</template>
<script>
import PeriodCollege_govem_id from "../../../components/admin/periodCollege_govem_id.vue";
import Alert_salary_gov from "../../../components/gov_salary/alert_salary_gov.vue";

export default {
  components: { PeriodCollege_govem_id,Alert_salary_gov },
  data() {
    return {
      period_college_id: "80105"

    };
  }
};
</script>
